<template>
    <div
        class="flex flex-col p-4 flex-1 min-h-0 gap-6 border-t-4"
        :class="isActive ? 'border-green-600 bg-card' : 'border-transparent opacity-50 bg-black'"
    >
        <SegmentPlayerCard :player="player" :is-active="isActive" />
        <SegmentsPointsProgress :score="score" :ceiling="ceiling" class="max-w-full w-full" />
        <SegmentsHitBreakdown :darts="darts" />
    </div>
</template>

<script>
import SegmentPlayerCard from '@/components/games/segments/SegmentsPlayerCard.vue'
import SegmentsPointsProgress from '@/components/games/segments/SegmentsPointsProgress.vue'
import SegmentsHitBreakdown from '@/components/games/segments/SegmentsHitBreakdown.vue'

export default {
    name: 'PointsVerticalPlayer',
    components: {
        SegmentPlayerCard,
        SegmentsPointsProgress,
        SegmentsHitBreakdown,
    },
    props: {
        player: {
            type: Object,
            required: true,
        },
        isActive: {
            type: Boolean,
            default: false,
        },
        // The team's running point total this leg (folds in live darts when active).
        score: {
            type: Number,
            default: 0,
        },
        currentRound: {
            type: Number,
            default: 1,
        },
        totalRounds: {
            type: Number,
            default: 1,
        },
        // Points ceiling to fill (Ceiling mode), or null in Rounds mode.
        ceiling: {
            type: Number,
            default: null,
        },
        // The current target segment, plus the next two, for the dartboard.
        targetSegment: {
            type: Object,
            default: null,
        },
        nextSegment: {
            type: Object,
            default: null,
        },
        thirdSegment: {
            type: Object,
            default: null,
        },
        // Darts thrown this leg, for the hit breakdown.
        darts: {
            type: Array,
            default: () => [],
        },
    },
}
</script>
